export function initialsFromUser(user) {
  const name = String(user?.displayName || user?.email || "").trim();
  if (!name) return "•";
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
  }
  if (name.includes("@")) {
    return name.slice(0, 2).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}

export function accountLabel(user) {
  const name = String(user?.displayName || "").trim();
  if (name) return name;
  const email = String(user?.email || "").trim();
  if (email) return email;
  return "My account";
}
